import React, {useState, useEffect} from 'react'
import { Form, Button, InputGroup, Row, Col, Alert } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { announcementService, authService, customerService } from '../../_services'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faX } from '@fortawesome/free-solid-svg-icons'
import DatePicker, { registerLocale } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import moment from 'moment'
import Select from 'react-select'
import TextareaAutosize from 'react-textarea-autosize'

const AnnouncementForm = ({data, handleChange, handleSubmit, validated}) => {

	const [customers, setCustomers] = useState([])
	const [announcementUsers, setAnnouncementUsers] = useState([])
	const [announcementDevices, setAnnouncementDevices] = useState([])
	const [hourValues, setHourValues] = useState([])
	const [minuteValues, setMinuteValues] = useState([])
    const {t} = useTranslation('common')

    useEffect(() => {
        if (authService.hasRoles(['ROLE_SUPER_ADMIN'])) {
	        customerService.getOptions().then(customers => {
	            customers.sort((a, b) => a.name.localeCompare(b.name))
	            setCustomers(customers)
	            if (data.customer === -1 && customers.length > 0) {
	                handleChange({target: {type: "select", name: "customerId", value: customers[0].id}})
	            }
	        })
        }

        announcementService.getUsers().then(users => {
            users.sort((a, b) => a.username.localeCompare(b.username))
            var announcementUsers = []
            users.forEach(user => {
                var announcementUser = data.users.find(announcementUser => announcementUser.user == user.id)
                if (announcementUser) {
                    announcementUser.username = user.username
                    announcementUser.customerName = user.customerName
                } else {
                    announcementUser = {
	                    id: null,
	                    announcement: null,
	                    user: user.id,
	                    username: user.username,
	                    customerName: user.customerName
	                }
                }
                announcementUsers.push(announcementUser)
            })
            setAnnouncementUsers(announcementUsers)
        })

        announcementService.getDevices().then(devices => {
            devices.sort((a, b) => a.username.localeCompare(b.username))
            var announcementDevices = []
            devices.forEach(device => {
                var announcementDevice = data.devices.find(announcementDevice => announcementDevice.device == device.id)
                if (announcementDevice) {
                    announcementDevice.username = device.username
                    announcementDevice.currentLicenseCode = device.currentLicenseCode
                    announcementDevice.osVersion = device.osVersion
                } else {
                    announcementDevice = {
	                    id: null,
	                    announcement: null,
	                    device: device.id,
	                    username: device.username,
	                    currentLicenseCode: device.currentLicenseCode,
	                    osVersion: device.osVersion
	                }
                }
                announcementDevices.push(announcementDevice)
            })
            setAnnouncementDevices(announcementDevices)
        })

        var hourValues = []
        for (var i = 0; i < 24; i++) {
            hourValues.push(i)
        }
        setHourValues(hourValues)

        var minuteValues = []
        for (var i = 0; i < 60; i++) {
            minuteValues.push(i)
        }
        setMinuteValues(minuteValues)
    }, [])

    const handleDateChange = (e, name) => {
        let newValue = moment(e).startOf('day').format('YYYY-MM-DD HH:mm:ss')
        handleChange({target: {type: "text", name: name, value: newValue}})
    }

    const handleHourChange = (e, dateName) => {
        console.log('handleHourChange')

        var currentDate = moment(data[dateName])
        currentDate.set('hour', e.target.value)

        let newValue = currentDate.format('YYYY-MM-DD HH:mm:ss')
        handleChange({target: {type: "text", name: dateName, value: newValue}})
    }

    const handleMinuteChange = (e, dateName) => {
        console.log('handleMinuteChange')

        var currentDate = moment(data[dateName])
        currentDate.set('minute', e.target.value)

        let newValue = currentDate.format('YYYY-MM-DD HH:mm:ss')
        handleChange({target: {type: "text", name: dateName, value: newValue}})
    }

    const clearDate = (name) => {
		handleChange({target: {type: "text", name: name, value: null}})
    }

    const onTranslationChange = (e, key) => {
		var newTranslations = {...data.translations}
		newTranslations[key] = e.target.value
		handleChange({target: {type: "object", name: "translations", value: newTranslations}})
    }

    function onPlatformChange(e) {
        console.log(e)
        if (e) {
            handleChange({target: {type: "select", name: "platforms", value: e}})
        } else {
            handleChange({target: {type: "select", name: "platforms", value: []}})
        }
    }

    function onUserChange(e) {
        console.log(e)
        handleChange({target: {type: "select", name: "users", value: e || []}})
    }

    function onDeviceChange(e) {
        console.log(e)
        handleChange({target: {type: "select", name: "devices", value: e || []}})
    }

    function filterDevices() {
        if (data.platforms.includes('ANDROID') && data.platforms.includes('IOS')) {
            return announcementDevices
        } else if (data.platforms.includes('ANDROID')) {
            return announcementDevices.filter(device => device.osVersion.includes('Android'))
        } else if (data.platforms.includes('IOS')) {
            return announcementDevices.filter(device => device.osVersion.includes('iOS'))
        }
        return []
    }

    const getUserOptionLabel = (announcementUser) => {
        if (authService.hasRoles(['ROLE_SUPER_ADMIN'])) {
            return announcementUser.username + ' (' + announcementUser.customerName + ')'
        }
        return announcementUser.username
    }

    const onCustomerChange = (e) => {
        handleChange({target: {type: "select", name: "customerId", value: e ? e.id : ""}})
    }

    const addLanguage = (e) => {
        var newTranslations = {...data.translations, [e]: ''}
        handleChange({target: {type: "object", name: "translations", value: newTranslations}})
    }

    const removeLanguage = (language) => {
        var newTranslations = {...data.translations}
        delete newTranslations[language]
        handleChange({target: {type: "object", name: "translations", value: newTranslations}})
    }

    return (
        <Form id="data-form" noValidate onSubmit={handleSubmit} validated={validated}>
            { authService.hasRoles(['ROLE_SUPER_ADMIN']) &&
                <Row>
	                <Col xl="6">
	                    <Form.Group controlId="customer">
			                <Form.Label>
			                    {t('user.columns.customer')}
			                </Form.Label>
			                <Select
			                    placeholder={t('user.columns.customer')}
			                    isLoading={customers.length === 0}
			                    options={customers}
			                    value={customers.find(customer => customer.id === data.customerId)}
			                    getOptionLabel={customer => customer.name}
			                    getOptionValue={customer => customer.id}
			                    onChange={onCustomerChange}
			                />
			            </Form.Group>
	                </Col>
	            </Row>
            }
            <Row>
	            <Col xl="3">
		            <Form.Group controlId="type">
						<Form.Label>
		                    {t('announcement.columns.type')}
		                </Form.Label>
		                <Form.Control required as="select" name="type" value={data.type} onChange={handleChange}>
		                    { ['PRIMARY', 'SECONDARY', 'SUCCESS', 'DANGER', 'WARNING', 'INFO', 'LIGHT', 'DARK'].map(type => {
		                        return <option key={type} value={type}>{type}</option>
		                    })}
		                </Form.Control>
					</Form.Group>
				</Col>
				<Col xl="9">
					<Alert
	                    style={{marginTop: '10px'}}
	                    variant={data.type.toLowerCase()}
	                    onClose={e => console.log(e)}
	                    dismissible={data.dismissible}
	                >
	                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
		            </Alert>
				</Col>
			</Row>
			<Form.Group controlId="translations">
				<Form.Label>
                    {t('announcement.columns.translations')}
                </Form.Label>
				<table className="table">
					<thead>
						<tr>
							<th>{t('announcement.language')}</th>
							<th>{t('announcement.text')}</th>
							<th style={{width: 30}}></th>
						</tr>
					</thead>
					<tbody>
					{ Object.entries(data.translations).map((entry, index) => {
						return <tr key={'entry-' + index}>
							<td>
								{entry[0]}
							</td>
							<td>
                                <TextareaAutosize
                                    className="form-control"
                                    placeholder={t('announcement.text')}
                                    name="value"
                                    value={entry[1]}
                                    onChange={e => onTranslationChange(e, entry[0])}
                                    required
                                />
							</td>
							<td>
								{ entry[0] != 'EN' &&
									<Button variant="outline-danger" size="sm" onClick={e => removeLanguage(entry[0])}>
										<FontAwesomeIcon icon={faTrash}/>
							        </Button>
						        }
							</td>
						</tr>
					})}
					</tbody>
				</table>
				<Select
                    placeholder={t('announcement.addlanguage')}
                    options={['SV', 'DA', 'PL'].filter(option => !data.translations[option])}
                    value={[]}
                    getOptionLabel={option => option}
                    getOptionValue={option => option}
                    closeMenuOnSelect={false}
                    onChange={addLanguage}
                />
			</Form.Group>
			<Form.Group controlId="platforms">
				<Form.Label>
                    {t('announcement.columns.platforms')}
                </Form.Label>
                <Select
                    placeholder={t('announcement.columns.platforms')}
                    options={['WEB', 'ANDROID', 'IOS']}
                    value={data.platforms}
                    getOptionLabel={platform => platform}
                    getOptionValue={platform => platform}
                    isMulti={true}
                    closeMenuOnSelect={false}
                    onChange={onPlatformChange}
                />
			</Form.Group>
			<Form.Group controlId="broadcast" style={{marginBottom: 0}}>
				<Form.Label>
                    <Form.Check type="checkbox" name="broadcast" label={t('announcement.columns.broadcast')} checked={data.broadcast} onChange={handleChange}/>
                </Form.Label>
			</Form.Group>
			{ !data.broadcast &&
				<>
					{ data.platforms.includes('WEB') &&
						<Form.Group controlId="announcementUsers">
							<Form.Label>
			                    {t('announcement.columns.users')}
			                </Form.Label>
			                <Select
			                    placeholder={t('announcement.columns.users')}
			                    isLoading={announcementUsers.length === 0}
			                    options={announcementUsers}
			                    value={data.users}
			                    getOptionLabel={getUserOptionLabel}
			                    getOptionValue={announcementUser => announcementUser.user}
			                    isMulti={true}
			                    closeMenuOnSelect={false}
			                    onChange={onUserChange}
			                />
						</Form.Group>
					}
					{ (data.platforms.includes('ANDROID') || data.platforms.includes('IOS')) &&
						<Form.Group controlId="announcementDevices">
							<Form.Label>
			                    {t('announcement.columns.devices')}
			                </Form.Label>
			                <Select
			                    placeholder={t('announcement.columns.devices')}
			                    isLoading={announcementDevices.length === 0}
			                    options={filterDevices()}
			                    value={data.devices}
			                    getOptionLabel={announcementDevice => announcementDevice.username + ' (' + announcementDevice.currentLicenseCode + ')'}
			                    getOptionValue={announcementDevice => announcementDevice.device}
			                    isMulti={true}
			                    closeMenuOnSelect={false}
			                    onChange={onDeviceChange}
			                />
						</Form.Group>
					}
				</>
			}
			<Form.Group controlId="dismissible" style={{marginBottom: 0}}>
				<Form.Label>
                    <Form.Check type="checkbox" name="dismissible" label={t('announcement.columns.dismissible')} checked={data.dismissible} onChange={handleChange}/>
                </Form.Label>
			</Form.Group>
			<Form.Group controlId="push">
				<Form.Label>
                    <Form.Check type="checkbox" name="push" label={t('announcement.columns.push')} checked={data.push} onChange={handleChange}/>
                </Form.Label>
			</Form.Group>
			<Form.Group controlId="startDate">
				<Form.Label>
                    {t('announcement.columns.startdate')}
                </Form.Label>
                <InputGroup>
                    <div style={{width: '150px'}}>
		                <DatePicker
		                    name="startDate"
		                    selected={data.startDate ? moment(data.startDate).toDate() : null}
		                    dateFormat="yyyy-MM-dd"
		                    onChange={e => handleDateChange(e, 'startDate')}
		                    className="form-control"
		                    showWeekNumbers
		                />
	                </div>
	                <div style={{width: '60px'}}>
						<Form.Control
							as="select"
							name="startHour"
							value={data.startDate ? moment(data.startDate).format('HH') : ''}
							onChange={e => handleHourChange(e, 'startDate')}
							required={data.startDate}
							disabled={!data.startDate}
						>
							<option value="">--</option>
							{ hourValues.map(hour => {
								return <option key={'hour-' + hour} value={hour < 10 ? '0' + hour : hour}>
									{ hour < 10 ? '0' : '' }{ hour }
								</option>
							})}
		                </Form.Control>
	                </div>
	                &nbsp;:&nbsp;
	                <div style={{width: '60px'}}>
		                <Form.Control
		                    as="select"
		                    name="startMinute"
		                    value={data.startDate ? moment(data.startDate).minutes() : ''}
		                    onChange={e => handleMinuteChange(e, 'startDate')}
		                    required={data.startDate}
		                    disabled={!data.startDate}
		                >
							<option value="">--</option>
							{ minuteValues.map(minute => {
								return <option key={'minute-' + minute} value={minute}>
									{ minute < 10 ? '0' : '' }{ minute }
								</option>
							})}
		                </Form.Control>
	                </div>
	                { data.startDate &&
		                <Button variant="outline-danger" onClick={e => clearDate('startDate')}>
							<FontAwesomeIcon icon={faX}/>
				        </Button>
			        }
		        </InputGroup>
			</Form.Group>
			<Form.Group controlId="endDate">
				<Form.Label>
                    {t('announcement.columns.enddate')}
                </Form.Label>
                <InputGroup>
                    <div style={{width: '150px'}}>
		                <DatePicker
		                    name="endDate"
		                    selected={data.endDate ? moment(data.endDate).toDate() : null}
		                    dateFormat="yyyy-MM-dd"
		                    onChange={e => handleDateChange(e, 'endDate')}
		                    className="form-control"
		                    showWeekNumbers
		                />
	                </div>
	                <div style={{width: '60px'}}>
						<Form.Control
							as="select"
							name="endHour"
							value={data.endDate ? moment(data.endDate).format('HH') : ''}
							onChange={e => handleHourChange(e, 'endDate')}
							required={data.endDate}
							disabled={!data.endDate}
						>
							<option value="">--</option>
							{ hourValues.map(hour => {
								return <option key={'hour-' + hour} value={hour < 10 ? '0' + hour : hour}>
									{ hour < 10 ? '0' : '' }{ hour }
								</option>
							})}
		                </Form.Control>
	                </div>
	                &nbsp;:&nbsp;
	                <div style={{width: '60px'}}>
		                <Form.Control
		                    as="select"
		                    name="endMinute"
		                    value={data.endDate ? moment(data.endDate).minutes() : ''}
		                    onChange={e => handleMinuteChange(e, 'endDate')}
		                    required={data.endDate}
		                    disabled={!data.endDate}
		                >
							<option value="">--</option>
							{ minuteValues.map(minute => {
								return <option key={'minute-' + minute} value={minute}>
									{ minute < 10 ? '0' : '' }{ minute }
								</option>
							})}
		                </Form.Control>
	                </div>
	                { data.endDate &&
		                <Button variant="outline-danger" onClick={e => clearDate('endDate')}>
							<FontAwesomeIcon icon={faX}/>
				        </Button>
			        }
		        </InputGroup>
			</Form.Group>
        </Form>
    )
}

export default AnnouncementForm